import React from 'react'
import { ActionIcon } from '@mantine/core'

function Icon({ width, height, color = 'currentColor' }) {
  return (
    <svg
      width={width}
      height={height}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      class="design-iconfont"
    >
      <path
        fill={color}
        d="M23.6127812,29.154 L8.38734375,29.154 C7.4855625,29.154 6.7559375,28.5241875 6.7559375,27.747875 L6.7559375,3.37275 C6.7559375,2.5965 7.4855625,1.966625 8.38734375,1.966625 L23.6127812,1.966625 C24.5144062,1.966625 25.2440312,2.5964375 25.2440312,3.37275 L25.2440312,27.747875 C25.2440312,28.5241875 24.5144062,29.154 23.6127812,29.154 L23.6127812,29.154 Z M15.9123588,27.747875 C17.0160053,27.747875 17.9125312,26.8509142 17.9125312,25.747875 C17.9125312,24.6448358 17.0160053,23.747875 15.9123588,23.747875 C14.8089423,23.747875 13.9125312,24.6448358 13.9125312,25.747875 C13.9124738,26.8509142 14.8089423,27.747875 15.9123588,27.747875 Z M8.3873125,4.778875 L8.3873125,21.778875 L23.6127812,21.778875 L23.6127812,4.778875 L8.3873125,4.778875 Z M10.7559375,7.966625 L21.7559375,7.966625 L21.7559375,10.966625 L10.7559375,10.966625 L10.7559375,7.966625 Z"
        fill-rule="nonzero"
      />
    </svg>
  )
}

const LoginByPhoneIcon = (props) => {
  const {
    fill = 'blue',
    variant = 'transparent',
    size = 'lg',
    radius = 'lg',
    width = 20,
    height = 20,
    loading = false,
    disabled = false,
  } = props
  return (
    <ActionIcon
      color={fill}
      variant={variant}
      size={size}
      radius={radius}
      loading={loading}
      disabled={disabled}
    >
      <Icon width={width} height={height} color={fill} />
    </ActionIcon>
  )
}

export default LoginByPhoneIcon
